import { render, staticRenderFns } from "./RascunhosCompanyModal.vue?vue&type=template&id=2da37281&"
import script from "./RascunhosCompanyModal.vue?vue&type=script&lang=js&"
export * from "./RascunhosCompanyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports